// @internal
import styled, { css } from 'styled-components';
import { fieldTokens } from '../../tokens/components/Field/tokens';
import { fieldControlWidth } from '../_common/Controller/styles';

/* @internal */
export const FieldControl = styled.div`
  // Don’t use rem unit. They inadvertedly resolve to fractional pixel values.
  // Fractional pixel values cause decimal number rounding problems, which
  // result in visual glitches (i.e. radio "dot" icon not centered.)
  // See https://github.com/carta/ink/pull/4541
  padding-bottom: ${fieldTokens.ContainerSpacingVerticalBaseDefault};
  padding-top: ${fieldTokens.ContainerSpacingVerticalBaseDefault};
  position: relative;

  ${({ theme }) =>
    theme.fieldDensity === 'low' &&
    css`
      padding-bottom: 3rem;
      padding-top: 3rem;
    `}

  ${({ theme }) =>
    theme.fieldDensity === 'high' &&
    css`
      padding-bottom: 10px;
      padding-top: 10px;
    `};

  ${({ theme }) =>
    !theme.fieldFull &&
    theme.fieldStacked &&
    css`
      max-width: ${fieldTokens.ContainerWidthBaseDefault};
    `}

  ${({ theme }) =>
    theme.fieldFull &&
    theme.fieldStacked &&
    css`
      max-width: none;
    `}
`;

/* @internal */
export const Required = styled.span`
  position: relative;
  &::after {
    color: ${fieldTokens.RequiredFontColorBaseDefault};
    content: '${fieldTokens.RequiredGraphicGlyphDefault}';
    display: inline;
    font-size: ${fieldTokens.RequiredFontSizeBaseDefault};
    font-weight: ${fieldTokens.RequiredFontWeightBaseDefault};
    line-height: 0.8;
    margin-left: 5px;
    position: relative;
    top: 7px;
  }
`;

/* @internal */
export const Label = styled.label`
  color: ${fieldTokens.LabelFontColorBaseDefault};
  font-size: ${fieldTokens.LabelFontSizeBaseDefault};
  font-weight: ${fieldTokens.LabelFontWeightBaseDefault};
  line-height: ${fieldTokens.LabelFontLeadingBaseDefault};
  position: relative;

  ${({ theme }) =>
    !theme.fieldStacked &&
    css`
      display: inline-block;
      margin-right: 16px;
      margin-top: 9px;
      text-align: right;
    `}

  ${({ theme }) =>
    theme.fieldRequired &&
    !theme.fieldStacked &&
    css`
      + ${Required} {
        position: absolute;
        right: 0;
        top: 9px;
      }
    `}

  ${({ theme }) =>
    theme.fieldMobile &&
    css`
      display: inline;
      margin-right: 0;
      margin-top: 0;
      text-align: left;
      + ${Required} {
        position: static;
      }
    `}
`;

/* @internal */
export const LabelWrapper = styled.div`
  position: relative;
  text-align: right;

  ${({ theme }) =>
    (theme.fieldStacked || theme.fieldMobile) &&
    css`
      margin-bottom: 4px;
      text-align: left;
    `}
`;

/* @internal */
export const ErrorWrapper = styled.div`
  margin-top: 8px;
  position: relative;
  text-align: left;
  max-width: ${fieldTokens.ContainerWidthBaseDefault};

  ${({ theme }) =>
    theme.fieldFull &&
    css`
      max-width: none;
    `}
`;

/* @internal */
export const FieldHelpWrapper = styled.div`
  max-width: ${fieldTokens.ContainerWidthBaseDefault};

  ${({ theme }) =>
    theme.fieldFull &&
    css`
      max-width: none;
    `}

  ${({ theme }) =>
    (theme.fieldStacked || theme.fieldMobile) &&
    css`
      margin-bottom: 8px;
    `}

  ${({ theme }) =>
    !theme.fieldStacked &&
    !theme.fieldMobile &&
    css`
      margin-top: 8px;
    `}

  ${({ theme }) =>
    theme.fieldLegacyHelp &&
    theme.fieldStacked &&
    css`
      margin-top: 8px;
      margin-bottom: 0;
    `}
`;

/* @internal */
export const InfoWrapper = styled.div`
  background: ${fieldTokens.InfoBackgroundColorBaseDefault};
  border-radius: ${fieldTokens.InfoBorderRadiusBaseDefault};
  color: ${fieldTokens.InfoFontColorBaseDefault};
  display: inline-block;
  font-size: ${fieldTokens.InfoFontSizeBaseDefault};
  font-weight: ${fieldTokens.InfoFontWeightBaseDefault};
  line-height: ${fieldTokens.InfoFontLeadingBaseDefault};
  margin-top: 8px;
  padding: 4px 8px;
  max-width: ${fieldTokens.ContainerWidthBaseDefault};

  ${({ theme }) =>
    theme.fieldFull &&
    css`
      max-width: none;
    `}
`;

/* @internal */
export const Attachment = styled.div`
  margin-left: 30px;
  width: ${fieldControlWidth}px;

  ${({ theme }) =>
    (theme.fieldMobile || theme.fieldStacked || theme.fieldFull) &&
    css`
      width: 100%;
    `}
`;

/* @internal */
export const Control = styled.div`
  width: ${fieldControlWidth}px;

  ${({ theme }) =>
    (theme.fieldMobile || theme.fieldStacked || theme.fieldFull) &&
    css`
      width: 100%;
    `}
`;
